module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAABiCAYAAACRdbl9AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAAaADAAQAAAABAAAAYgAAAAAnsJBjAAABAklEQVQYGUWPS1LDQAxEpdbYmE/IJndgwXk4erY5AMWGbJKYkURrHIoql+upW90zIx+ZJnI8zpCnT0Ae3oDD+Wz4mibg9Xo1nFsDXsyAWFdDFi2tk1YAl06S0mYrDaTsTo0m0v+JjszUZA3uTUoKkijJijphG4dhZWSOlTKEjeLekFLZcgXKgogak6VDi9JauZ3atldZjBW+965tyzWKRhU4JEmRJFXlyPtTS7oJUmla7qYh/ijoKioR5RY5+LXKumq/J2IrYN/I1orGaOEb1IzZSqqVdittWTpXLoHVm2NxJz0b+6LT/Zl4zDwzUQaWm+N7fWR2t+PvdAq87/cuvK79Atz+ofEeYZ6PAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/new/dashboard/fgx.png
// module id = feqA
// module chunks = 8